import React, { useState } from "react";
import firebase from "firebase/compat/app";

import "@firebase/storage";
import "@firebase/firestore";

export const UploadImg = () => {
  let file = null;
  const upload = () => {
    file = document.getElementById("files").files;
    console.log(file[0]);
  };

  const check = () => {
    console.log(file[0]);
  };

  return (
    <div>
      <input type="file" onChange={upload} id="files" />
      <button onClick={check}>Test</button>

      <img src={file} alt="" />
    </div>
  );
};
